import React, { Component } from 'react';
import Helmet from 'react-helmet';
import BrowserUtils from '../../utils/BrowserUtils';

/**
 * @todo investigate whether this component will actually be rendered.
 * It's included in AppRouter, but will users ever navigate to `/logout`?
 * I'm not convinced.
 */
class LogoutPage extends Component {
  componentDidMount() {
    BrowserUtils.setViewPort(1);
  }

  render() {
    return (
      <div>
        <Helmet title="Financial Stories" />
        <div className="b-app authenticate-account container-fluid">
          <h1>Logout Page</h1>
        </div>
      </div>
    );
  }
}

export { LogoutPage };
